import { auth } from '@/features/auth/types';
import type { PlayerDetailStats } from '@/features/guardian-player/components/player-detail/types';
import type { PlayerSessionSummaryResponse } from '@/features/guardian-player/types';
import type { GuardianPlayer } from '@/features/guardian/services/get-guardian-players';
import { isValid, parseISO } from 'date-fns';

export function calculateAge(dob?: string): number | null {
  if (!dob) return null;
  const birthDate = parseISO(dob);
  if (!isValid(birthDate)) return null;

  const now = new Date();
  let age = now.getFullYear() - birthDate.getFullYear();
  const monthDiff = now.getMonth() - birthDate.getMonth();
  const hasNotHadBirthdayYet =
    monthDiff < 0 || (monthDiff === 0 && now.getDate() < birthDate.getDate());
  if (hasNotHadBirthdayYet) {
    age -= 1;
  }

  return age >= 0 ? age : null;
}

export function buildPlayerDetailStats(
  player: GuardianPlayer,
  sessionSummary?: PlayerSessionSummaryResponse,
): PlayerDetailStats {
  const rawPlayer = player as any;
  return {
    sessions: sessionSummary?.totalSessions?.toString() ?? '0',
    packageLeft: rawPlayer.packageLeft?.toString() || '-/-',
    upcoming: rawPlayer.upcoming?.toString() || '-',
    numberGuardian: player.numberGuardian?.toString() || '-',
  };
}

export function calculatePlayerProgress(level: number, progress?: auth.ProgressLevel[]) {
  if (!progress || progress.length === 0) return null;

  const currentLevelProgress = progress[level - 1];
  if (!currentLevelProgress || !currentLevelProgress.badges) return null;

  const earnedCount = currentLevelProgress.badges.filter(badge => badge.badgeEarned).length;
  const totalCount = Math.max(currentLevelProgress.badges.length, 5);

  return { earnedCount, totalCount };
}

export * from './co-guardian-profile';
export * from './date';
export * from './guardian-circle';
export * from './level-detail';
export * from './pin-image';
export * from './player-session-detail';
